export default __webpack_public_path__ + "static/media/categorie_biodiversite.cacd07e7.jpg";